module.exports = __webpack_public_path__ + "static/img/city-mob-gold-2.8a7248a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-mob-gold-2.png
// module id = 1066
// module chunks = 173